import { Container } from './Spacer.style';

const Spacer = ({ w, width, h, height, grow }) => {
  return <Container w={w} width={width} h={h} height={height} grow={grow} />;
};
export default Spacer;
